// eslint-disable-next-line import/no-import-module-exports
import React from 'react';
// eslint-disable-next-line import/no-import-module-exports
import { createRoot, Root } from 'react-dom/client';
// eslint-disable-next-line import/no-import-module-exports
import App from './App';

const ROOT_ELEMENT_ID = 'gamiphy-root';

const getRoot = (): Root => {
  const createElement = (): HTMLDivElement => {
    const element = document.createElement('div');
    element.id = ROOT_ELEMENT_ID;

    document.body.appendChild(element);

    return element;
  };

  return createRoot(document.getElementById(ROOT_ELEMENT_ID) || createElement());
};

if (window.document.body) {
  getRoot().render(<App />);
} else {
  window.addEventListener('load', () => {
    getRoot().render(<App />);
  });
}

if (module.hot) {
  module.hot.accept();
}
